import { useState, useRef, useEffect } from "react";

function shuffle(arr) {
  const a = [...arr];
  for (let i = a.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [a[i], a[j]] = [a[j], a[i]];
  }
  return a;
}

export default function PuzzlePlayer({ game, onComplete }) {
  const grid = game.grid || 3;
  const n = grid * grid;
  const [order, setOrder] = useState([]);
  const [selected, setSelected] = useState(null);
  const swaps = useRef(0);
  const start = useRef(Date.now());
  const done = useRef(false);

  useEffect(() => {
    let o = shuffle([...Array(n).keys()]);
    if (o.every((v, i) => v === i)) o = shuffle(o);
    setOrder(o);
  }, [n]);

  if (!game.image_url) {
    return <p className="text-center text-xl font-patient text-gray-500 mt-10">Ce puzzle n'a pas encore d'image.</p>;
  }

  const finishIfSolved = (o) => {
    if (!done.current && o.every((v, i) => v === i)) {
      done.current = true;
      const duration = Math.round((Date.now() - start.current) / 1000);
      const extra = Math.max(0, swaps.current - n);
      const acc = Math.max(40, 100 - extra * 4);
      setTimeout(() => onComplete({ score: acc, accuracy: acc, duration }), 500);
    }
  };

  const tap = (slot) => {
    if (done.current) return;
    if (selected === null) {
      setSelected(slot);
    } else if (selected === slot) {
      setSelected(null);
    } else {
      const o = [...order];
      [o[selected], o[slot]] = [o[slot], o[selected]];
      swaps.current += 1;
      setOrder(o);
      setSelected(null);
      finishIfSolved(o);
    }
  };

  const tileStyle = (tileId) => {
    const col = tileId % grid;
    const row = Math.floor(tileId / grid);
    return {
      backgroundImage: `url(${game.image_url})`,
      backgroundSize: `${grid * 100}% ${grid * 100}%`,
      backgroundPosition: `${(col / (grid - 1)) * 100}% ${(row / (grid - 1)) * 100}%`,
    };
  };

  return (
    <div className="w-full max-w-md mx-auto text-center" data-testid="puzzle-player">
      <p className="text-2xl font-patient font-bold text-gray-700 mb-4">
        Touchez deux pièces pour les échanger et reconstituer l'image
      </p>
      <div className="flex items-center justify-center gap-4 mb-4">
        <img src={game.image_url} alt="modèle" className="w-20 h-20 rounded-xl object-cover border-4 border-amber-200" />
        <span className="text-sm font-patient text-gray-500">Modèle</span>
      </div>
      <div
        className="mx-auto rounded-2xl overflow-hidden border-4 border-emerald-700/20"
        style={{ display: "grid", gridTemplateColumns: `repeat(${grid}, 1fr)`, gap: 3, width: "min(90vw, 26rem)", aspectRatio: "1" }}
      >
        {order.map((tileId, slot) => (
          <button
            key={slot}
            data-testid={`puzzle-tile-${slot}`}
            onClick={() => tap(slot)}
            style={tileStyle(tileId)}
            className={`w-full h-full transition-transform duration-150 active:scale-95 ${
              selected === slot ? "ring-4 ring-amber-400 z-10 scale-95" : ""}`}
          />
        ))}
      </div>
    </div>
  );
}
